<template>
  <div style="background: #fbfafa">
    <!-- 导航栏 + 倒计时框-->
    <div style="width: 100%;height:108px;position: fixed;top:0;z-index: 6;">
      <div style="width: 100%;height:61px;background: #000;">
        <div style="width: 1730px;height: 97px; margin: 0 auto;">
          <Header
            v-if="this.identity !== ''"
            :activeIndex="activeIndex"
            :userName="userName"
            :identity="identity"
            :teacherGroup="teacherGroup"
            :role="role"
          />
        </div>
      </div>
      <div id="textp">
        <div><span>常规任务</span><span>＞</span><span>作文批改</span></div>
        <div>{{ countDown }}</div>
        <div style="margin: 10px 10px 0 0;display: flex;">
          <el-button
            class="temporary_btn"
            style="margin-right: 20px"
            type="warning"
            @click="cache(1)">
            暂存
          </el-button>
          <el-button class="submit_btn" type="warning" @click="cache(0)">
            提交
          </el-button>
        </div>
      </div>
    </div>
    <!-- 内容区域 -->
    <el-container
      style="padding: 0 24px; width: 1320px; margin: 120px auto 10px; background: #fff;border-top: 1px solid #ebeef5;"
    >
      <el-main style="padding: 0;width:1000px;overflow: visible;">
        <div class="middle_content" style="line-height: 40px;width:1000px;">
          <div>
            <el-button
              v-if="isSubInfo === 1"
              type="primary"
              @click="openDialog"
              style="height: 35px"
            >
              查看写作要求
            </el-button>
            <div
              style="
                height: 25px;
                border: 0.1px solid #e6e1e1;
                margin: 0 20px 0;
              "
            ></div>
            <!--this.correctType === 3 && 去掉对精粗批的判断  -->
            <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
              <img
                src="../../assets/images/compile.png"
                alt="图片加载失败"
                style="width: 25px"
              />
              <span v-if="tabType === 'allTags'" style="color: #ffc107;">
                使用鼠标选中句子或单词可进行精细点评
              </span>
              <span v-if="tabType !== 'allTags'" style="color: #ffc107">
                请点击右侧"所有批注"栏进入批改状态
              </span>
            </div>
          </div>
          <div class="dialog" id="drag">
            <div style="margin: 10px 0; font-size: 25px; text-align: center">
              写作说明
            </div>
            <div
              style="
                position: absolute;
                top: 10px;
                right: 20px;
                width: 30px;
                height: 30px;
                font-size: 35px;
                cursor: default;
              "
              @click="closeDialog"
            >
              <i class="el-icon-close"></i>
            </div>
            <hr style="width: 90%" />
            <!-- 展示写作说明的可拖拽弹框 -->
            <div v-if="this.source === 1" class="title_cover">
              <div
                class="requirements"
                v-if="requirements.title && requirements.title !== null"
              >
                <div>题目:</div>
                <div>{{ requirements.title }}</div>
              </div>
              <div class="requirements" v-if="requirements.introductions">
                <div>要求:</div>
                <div style="word-break: break-word">
                  {{ requirements.introductions }}
                </div>
              </div>
              <div
                v-if="requirements.pictures && requirements.pictures.length > 0"
              >
                <div class="img">附图:</div>
                <div style="margin-left: 0px; display: flex">
                  <div v-for="(item, i) in requirements.pictures" :key="i">
                    <el-image
                      style="margin-left: 75px; max-width: 500px"
                      :src="item"
                      alt="图片加载失败"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
              <div
                v-if="requirements.starts"
                class="requirements begin"
                style="display: flex"
              >
                <div>起始句:</div>
                <div style="word-break: break-word">
                  {{ requirements.starts }}
                </div>
              </div>
              <div
                class="requirements2"
                v-if="requirements.examples && requirements.examples.length > 0"
              >
                <span>参考范文:</span>
                <div v-for="(item, i) in requirements.examples" :key="i">
                  <div
                    style="
                      margin: 0 50%;
                      width: 30px;
                      height: 30px;
                      border: 1px solid #666;
                      border-radius: 50%;
                      text-align: center;
                      line-height: 30px;
                      background: #409eff;
                    "
                  >
                    {{ i + 1 }}
                  </div>
                  <div
                    style="
                      word-break: break-word;
                      text-align: justify;
                      font-size: 20px;
                    "
                    v-html="requirements.examples[i]"
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="this.source === 2" class="title_cover">
              <div class="requirements">
                <div>题目:</div>
                <div
                  v-if="
                    requirements.custom_title &&
                      requirements.custom_title !== null
                  "
                >
                  {{ requirements.custom_title }}
                </div>
              </div>
              <div
                v-if="
                  requirements.custom_title_img &&
                    requirements.custom_title_img !== null
                "
              >
                <el-image
                  style="margin-left: 75px; max-width: 500px"
                  :src="requirements.custom_title_img"
                  alt="图片加载失败"
                >
                </el-image>
              </div>
              <div class="requirements">
                <div style="width: 135px">写作指导:</div>
                <div
                  v-if="
                    requirements.main_idea && requirements.main_idea !== null
                  "
                >
                  {{ requirements.main_idea }}
                </div>
              </div>
              <div
                v-if="
                  requirements.main_idea_img &&
                    requirements.main_idea_img !== null
                "
              >
                <el-image
                  style="margin-left: 75px; max-width: 500px"
                  :src="requirements.main_idea_img"
                  alt="图片加载失败"
                >
                </el-image>
              </div>
              <div class="requirements">
                <div>范文:</div>
                <div v-if="requirements.hint && requirements.hint !== null">
                  {{ requirements.hint }}
                </div>
              </div>
              <div
                v-if="requirements.hint_img && requirements.hint_img !== null"
              >
                <el-image
                  style="margin-left: 75px; max-width: 500px"
                  :src="requirements.hint_img"
                  alt="图片加载失败"
                >
                </el-image>
              </div>
            </div>
          </div>
          <div class="essay_cover" @mouseup="selectMethod">
            <p v-html="essay" class="content"></p>
          </div>
        </div>
        <CorrectBox
          :show="dialogVisible"
          :conceal="conceal"
          ref="c1"
          :confirm="handleSubmit"
          :handleClose="handleClose"
        />
        <div class="right_border">
          <ul class="statistics">
            <li>
              <div>单词数</div>
              <span>{{ word_count }}</span>
              <span>个</span>
            </li>
            <li>
              <div>独立词数</div>
              <span>{{ unique_word }}</span>
              <span>个</span>
            </li>
            <li>
              <div>句子个数</div>
              <span>{{ sentence_count }}</span>
              <span>句</span>
            </li>
            <li>
              <div>平均句长</div>
              <span>{{ avg_sentence_len }}</span>
              <span>词</span>
            </li>
            <li>
              <div>简单句数</div>
              <span>{{ sentence_simple_count }}</span>
              <span>句</span>
            </li>
            <li>
              <div>并列句数</div>
              <span>{{ sentence_compound_count }}</span>
              <span>句</span>
            </li>
            <li>
              <div>复合句数</div>
              <span>{{ sentence_complex_count }}</span>
              <span>句</span>
            </li>
            <li>
              <div>并列复合句数</div>
              <span>{{ sentence_compound_complex_count }}</span>
              <span>句</span>
            </li>
          </ul>
          <div>
            <el-button type="primary" plain @click="wordEchartShow = true">
              查看详情
            </el-button>
            <CorrectDialog
              :show="wordEchartShow"
              :statistics="statistics"
              :conceal="conceal"
            />
          </div>
        </div>
      </el-main>
      <el-aside
        style="background-color: rgb(238, 241, 246); height: 450px;width: 280px;"
      >
        <el-menu
          default-active="allTags"
          :default-openeds="['allTags']"
          @select="handleSelect"
          background-color="#eeeaea99"
          style="height:450px;"
        >
          <el-menu-item index="allTags">
            <i class="el-icon-menu"></i>
            <span style="font-size: 20px; font-weight: bold"> 所有批注 </span>
            <div class="tag_num" style="margin-left: 30px">
              {{ tags.allTags }}
            </div>
          </el-menu-item>
          <!--  -->
          <el-menu-item
            :class="
              tags.allErrs === 0 ? 'menu_first' : 'menu_first subtract_score'
            "
            index="allErrs"
          >
            <i
              :class="
                tags.allErrs === 0
                  ? 'el-icon-warning'
                  : 'el-icon-warning subtract_score'
              "
            ></i>
            <div class="tag_type">扣分项</div>
            <div class="tag_num">{{ tags.allErrs }}</div>
          </el-menu-item>
          <el-menu-item-group>
            <el-menu-item
              :class="
                tags.cacography === 0
                  ? 'menu_style'
                  : 'menu_style subtract_score'
              "
              index="cacography"
            >
              <div class="err_type">拼写错误</div>
              <div class="err_num">{{ tags.cacography }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.syntax === 0 ? 'menu_style' : 'menu_style subtract_score'
              "
              index="syntax"
            >
              <div class="err_type">语法错误</div>
              <div class="err_num">{{ tags.syntax }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.semantic === 0 ? 'menu_style' : 'menu_style subtract_score'
              "
              index="semantic"
            >
              <div class="err_type">语义错误</div>
              <div class="err_num">{{ tags.semantic }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.pragmatic === 0
                  ? 'menu_style'
                  : 'menu_style subtract_score'
              "
              index="pragmatic"
            >
              <div class="err_type">语用错误</div>
              <div class="err_num">{{ tags.pragmatic }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.structure === 0
                  ? 'menu_style'
                  : 'menu_style subtract_score'
              "
              index="structure"
            >
              <div class="err_type">结构错误</div>
              <div class="err_num">{{ tags.structure }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.content === 0 ? 'menu_style' : 'menu_style subtract_score'
              "
              index="content"
            >
              <div class="err_type">内容错误</div>
              <div class="err_num">{{ tags.content }}</div>
            </el-menu-item>
            <el-menu-item
              :class="
                tags.otherErrs === 0
                  ? 'menu_style'
                  : 'menu_style subtract_score'
              "
              index="otherErrs"
            >
              <div class="err_type">其他错误</div>
              <div class="err_num">{{ tags.otherErrs }}</div>
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item
            :class="
              tags.lightspot === 0 ? 'menu_first' : 'menu_first add_score'
            "
            index="lightspot"
          >
            <template slot="title">
              <i
                :class="
                  tags.lightspot === 0
                    ? 'iconfont  icon-circularwuxing'
                    : 'iconfont  icon-circularwuxing-copy'
                "
              ></i>
              <div class="tag_type">加分项</div>
              <div class="tag_num">{{ tags.lightspot }}</div>
            </template>
          </el-menu-item>
          <el-menu-item
            :class="tags.others === 0 ? 'menu_first' : 'menu_first other_score'"
            index="others"
          >
            <template slot="title">
              <i
                :class="
                  tags.others === 0
                    ? 'iconfont icon-shenglvehao'
                    : 'iconfont icon-shenglvehao-copy'
                "
              ></i>
              <div class="tag_type">其他项</div>
              <div class="tag_num">{{ tags.others }}</div>
            </template>
          </el-menu-item>
        </el-menu>
      </el-aside>
    </el-container>
    <!-- 评价打分部分 -->
    <div class="evaluate_details">
      <!-- 整体评价 -->
      <div>
        <el-row>
          <el-col :span="20">
            <div
              style="
                font-size: 25px;
                font-weight: bolder;
                color: #333;
                float: left;
              "
            >
              整体评价
            </div>
          </el-col>
          <el-col :span="4">
            <div style="margin-top: 5px">
              <span style="color: #333; font-weight: bolder"
                >AI评分参考: {{ yd_ref_score.score }}</span
              >
              <a
                href="#"
                style="
                  display: inline-block;
                  color: #85b0ff;
                  width: 80px;
                  margin-left: 20px;
                "
                @click="referenceDialogVisible = true"
              >
                查看详情>>
              </a>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-dialog
        title="智能评分"
        :visible.sync="referenceDialogVisible"
        width="30%"
      >
        <el-row>
          <el-col :span="8" :offset="4">
            <div
              style="
                width: 120px;
                height: 120px;
                border-radius: 120px;
                text-align: center;
                line-height: 120px;
                font-size: 45px;
                font-weight: bold;
                color: #0b83e2;
                background: #e6e3e2;
                margin-top: 15px;
              "
            >
              {{ yd_ref_score.score }}
            </div>
          </el-col>
          <el-col :span="11" :offset="1">
            <div style="margin-bottom: 5px; font-size: 16px">
              词汇得分：
              <span style="color: #555; font-weight: bold; font-size: 20px">{{
                yd_ref_score.majorscore_word
              }}</span>
            </div>
            <div style="margin-bottom: 5px; font-size: 16px">
              语法得分：
              <span style="color: #555; font-weight: bold; font-size: 20px">{{
                yd_ref_score.majorscore_grammar
              }}</span>
            </div>
            <div style="margin-bottom: 5px; font-size: 16px">
              逻辑得分：
              <span style="color: #555; font-weight: bold; font-size: 20px">{{
                yd_ref_score.majorscore_structure
              }}</span>
            </div>
            <div style="margin-bottom: 5px; font-size: 16px">
              内容得分：
              <span style="color: #555; font-weight: bold; font-size: 20px">{{
                yd_ref_score.majorscore_topic
              }}</span>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <el-row :gutter="20">
        <!-- dimension.wordName -->
        <el-col :span="8">
          <div class="card_cover">
            <div class="header_card">
              <el-divider direction="vertical" class="divider_css"></el-divider>
              {{
                `${dimension.wordName}(总分占比${scoreArea.word}%，分值区间0-${
                  scoreArea.word
                }分)`
              }}
            </div>
            <div class="box_card">
              <el-row style="margin: 0; line-height: 40px">
                <el-col :span="9">
                  <a-rate
                    v-model="wordStar"
                    class="star_location"
                    allowClear
                    @change="wordStarChange"
                  />
                </el-col>
                <el-col :span="15">
                  <el-select
                    value=""
                    placeholder="请选择评语"
                    style="width: 100%"
                    @change="wordSelectChange"
                  >
                    <el-option
                      v-for="item in evaluate.word.comments"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <div>
                <el-input
                  type="textarea"
                  v-model="ruleForm.comments.word.text"
                  resize="none"
                  rows="5"
                  :placeholder="`请输入对${dimension.wordName}的评价(最大输入200字)`"
                  maxlength="200"
                  style="font-size: 18px"
                ></el-input>
              </div>
              <el-row class="score_height">
                <el-col :span="4"><div class="score_size">得分</div></el-col>
                <el-col :span="20">
                  <select
                    v-model="ruleForm.comments.word.subscore"
                    @change="scoreChange"
                    class="score_select"
                  >
                    <option
                      v-for="item in evaluate.word.scoreOptions"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </el-col>
              </el-row>
            </div>
            <div class="box_info">
              系统根据您给评的星级与评语智能推荐得分区间
            </div>
          </div>
        </el-col>
        <!-- dimension.sentenceName -->
        <el-col :span="8">
          <div class="card_cover">
            <div class="header_card">
              <el-divider direction="vertical" class="divider_css"></el-divider>
              {{
                `${dimension.sentenceName} (总分占比${scoreArea.sentence}%，分值区间0-${
                  scoreArea.sentence
                }分)`
              }}
            </div>
            <div class="box_card">
              <el-row style="margin: 0; line-height: 40px">
                <el-col :span="9">
                  <a-rate
                    v-model="sentenceStar"
                    class="star_location"
                    @change="sentenceStarChange"
                  />
                </el-col>
                <el-col :span="15">
                  <el-select
                    value=""
                    placeholder="请选择评语"
                    style="width: 100%"
                    @change="sentenceSelectChange"
                  >
                    <el-option
                      v-for="item in evaluate.sentence.comments"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <div>
                <el-input
                  type="textarea"
                  v-model="ruleForm.comments.sentence.text"
                  resize="none"
                  rows="5"
                  :placeholder='`请输入对${dimension.sentenceName}的评价(最大输入200字)`'
                  maxlength="200"
                  style="font-size: 18px"
                ></el-input>
              </div>
              <el-row class="score_height">
                <el-col :span="4"><div class="score_size">得分</div></el-col>
                <el-col :span="20">
                  <select
                    v-model="ruleForm.comments.sentence.subscore"
                    @change="scoreChange"
                    class="score_select"
                  >
                    <option
                      v-for="item in evaluate.sentence.scoreOptions"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </el-col>
              </el-row>
            </div>
            <div class="box_info">
              系统根据您给评的星级与评语智能推荐得分区间
            </div>
          </div>
        </el-col>
        <!-- dimension.structureName -->
        <el-col :span="8">
          <div class="card_cover">
            <div class="header_card">
              <el-divider direction="vertical" class="divider_css"></el-divider>
              {{
                `${dimension.structureName}(总分占比${scoreArea.structure}%，分值区间0-${
                  scoreArea.structure
                }分)`
              }}
            </div>
            <div class="box_card">
              <el-row style="margin: 0; line-height: 40px">
                <el-col :span="9">
                  <a-rate
                    v-model="structureStar"
                    class="star_location"
                    @change="structureStarChange"
                  />
                </el-col>
                <el-col :span="15">
                  <el-select
                    value=""
                    placeholder="请选择评语"
                    style="width: 100%"
                    @change="structureSelectChange"
                  >
                    <el-option
                      v-for="item in evaluate.structure.comments"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <div>
                <el-input
                  type="textarea"
                  v-model="ruleForm.comments.structure.text"
                  resize="none"
                  rows="5"
                  :placeholder="`请输入对${dimension.structureName}的评价(最大输入200字)`"
                  maxlength="200"
                  style="font-size: 18px"
                ></el-input>
              </div>
              <el-row class="score_height">
                <el-col :span="4"><div class="score_size">得分</div></el-col>
                <el-col :span="20">
                  <select
                    v-model="ruleForm.comments.structure.subscore"
                    @change="scoreChange"
                    class="score_select"
                  >
                    <option
                      v-for="item in evaluate.structure.scoreOptions"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </el-col>
              </el-row>
            </div>
            <div class="box_info">
              系统根据您给评的星级与评语智能推荐得分区间
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <!-- 卷面整洁 -->
          <div class="card_cover" v-if="this.imgList.length > 0">
            <div class="header_card">
              <el-divider direction="vertical" class="divider_css"></el-divider
              >卷面整洁
            </div>
            <div class="box_card">
              <div class="box_card_div">
                <div>卷面分扣除</div>
                <div class="correctFrame" v-if="imgList.length > 0">
                  <div style="width: 100px;">作文原图：</div>
                  <el-image 
                    :src="imgList[0]" 
                    :preview-src-list="imgList"
                    style="width: 40px;height:40px;margin: 5px 10px;"
                  >
                  </el-image>
                </div>
              </div>
              <div class="clean_style" @cliack="scoreChange">
                <el-radio-group
                  v-model="ruleForm.comments.tidyScore"
                  @change="scoreChange"
                  style="margin-left: 0px;overflow: auto;"
                >
                  <el-radio-button class="score_radio" :label="0" border
                    >0分</el-radio-button
                  >
                  <el-radio-button class="score_radio" :label="-1" border
                    >1分</el-radio-button
                  >
                  <el-radio-button class="score_radio" :label="-2" border
                    >2分</el-radio-button
                  >
                  <el-radio-button class="score_radio" :label="-3" border
                    >3分</el-radio-button
                  >
                  <el-radio-button class="score_radio" :label="-4" border
                    >4分</el-radio-button
                  >
                  <el-radio-button class="score_radio" :label="-5" border
                    >5分</el-radio-button
                  >
                </el-radio-group>
              </div>
              <el-row style="margin: 0; line-height: 24px">
                <el-col :span="4"><div class="score_size">得分</div></el-col>
                <el-col :span="20">
                  <input
                    type="text"
                    v-model="ruleForm.comments.tidyScore"
                    disabled
                    style="
                      width: 100%;
                      font-size: 20px;
                      font-weight: bold;
                      color: #ffb800;
                      padding-left: 8px;
                      height: 39px;
                      border: 0;
                    "
                  />
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <!-- 作文点评 -->
          <div style="width: 100%">
            <div class="header_card">
              <el-divider direction="vertical" class="divider_css"></el-divider>
              作文点评
            </div>
            <div>
              <el-input
                type="textarea"
                v-model="ruleForm.comments.summary"
                resize="none"
                rows="5"
                placeholder="请输入对作文的综合评价(最大输入500字)"
                maxlength="500"
                style="font-size: 18px"
              ></el-input>
            </div>
            <div>
              <el-row :gutter="20" style="margin: 0">
                <el-col :span="16" class="record-col record-right">
                  <div style="margin: 10px 0">语音点评</div>
                  <div class="record">
                    <div>
                      <div v-if="this.recordStatus === 2" class="timer">
                        {{ str }}
                      </div>
                      <audio
                        controls
                        style="width: 100%"
                        v-show="isFinished"
                      ></audio>
                    </div>
                    <div>
                      <el-button-group>
                        <el-button
                          class="button_size"
                          v-if="this.recordStatus === 1"
                          type="primary"
                          @click="startRecord(0)"
                        >
                          开始录音
                        </el-button>
                        <el-button
                          class="button_size"
                          v-if="this.recordStatus === 2"
                          type="primary"
                          @click="play"
                        >
                          完成录音
                        </el-button>

                        <el-button
                          class="button_size"
                          v-if="this.recordStatus === 3"
                          type="primary"
                          @click="startRecord(1)"
                        >
                          重新录音
                        </el-button>
                        <el-button
                          class="button_size"
                          style="margin-left: 20px"
                          v-if="this.recordStatus === 3"
                          type="danger"
                          @click="clear"
                        >
                          删除
                        </el-button>
                      </el-button-group>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8" class="record-col">
                  <div style="position: relative; border: 0; border: 0">
                    <div
                      style="
                        font-size: 16px;
                        font-weight: 600;
                        height: 45px;
                        line-height: 45px;
                      "
                    >
                      总评得分
                      <span style="font-size: 10px">( 满分100 )</span>
                    </div>
                    <div
                      style="
                        width: 100%;
                        height: 65px;
                        text-align: center;
                        line-height: 65px;
                        position: absolute;
                        top: 80%;
                        font-size: 60px;
                        font-weight: 600;
                        color: #f00;
                      "
                    >
                      {{ ruleForm.score }}
                    </div>
                  </div>
                  <!-- <input
                    type="text"
                    v-model="ruleForm.score"
                    disabled
                    style="width:90%;font-size:30px;font-weight:bold;color:#f00;"
                  /> -->
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <div style="margin: 20px; text-align: center">
        <el-button
          class="temporary_btn"
          style="margin-right: 20px"
          type="primary"
          @click="cache(1)"
          >暂存</el-button
        >
        <el-button class="submit_btn" type="primary" @click="cache(0)"
          >提交</el-button
        >
      </div> -->
    </div>
    <!-- 系统批改详情 -->
    <div class="correct_details">
      <div class="correct_details_title">系统批改详情</div>
      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(item, index) in details2"
          :key="index"
          :title="
            '第 ' +
              pids.find((n, index) => index + 1 === item.pid) +
              ' 段 [ ' +
              item.sentences.length +
              ' ]'
          "
          :name="index"
        >
          <div
            v-for="(item1, index1) in item.sentences"
            :key="index1"
            style="display: flex"
          >
            <div class="original_text">
              <span style="font-weight: 600; width: 100%; overflow: hidden"
                >{{ item1.sentence.gsid }}.&nbsp;&nbsp;
              </span>
              <span
                style="width: 100%; overflow: hidden"
                v-html="item1.sentenceSolo"
              ></span>
            </div>
            <div
              class="annotation"
              style="display: inline-block; width: 40%; font-size: 15px"
            >
              <ul
                v-for="(item2, index2) in reverseList(tagList)"
                :key="index2"
                style="word-break: break-all"
              >
                <li
                  v-if="
                    item2.offset >= item1.sentence.offset &&
                      item2.offset <
                        item1.sentence.offset + item1.sentence.length
                  "
                >
                  <div
                    class="add"
                    v-if="item2.issueType.indexOf('加分项') >= 0"
                  >
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #3db95c"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                  <div
                    class="reduce"
                    v-if="item2.issueType.indexOf('扣分项') >= 0"
                  >
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #fc500d"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                  <div
                    class="other_tags"
                    v-if="item2.issueType.indexOf('其他项') >= 0"
                  >
                    <span class="tags_badge">{{ index2 + 1 }}</span>
                    <span style="color: #5e79fd"
                      >[ {{ item2.issueType }} ]</span
                    >
                  </div>
                </li>
                <li
                  class="annotation_li"
                  v-if="
                    item2.offset >= item1.sentence.offset &&
                      item2.offset <
                        item1.sentence.offset + item1.sentence.length
                  "
                >
                  <div>标注词句：</div>
                  <div>{{ essay1.substr(item2.offset, item2.length) }}</div>
                </li>
                <li
                  class="annotation_li"
                  v-if="
                    item2.offset >= item1.sentence.offset &&
                      item2.offset <
                        item1.sentence.offset + item1.sentence.length
                  "
                >
                  <div>批改说明：</div>
                  <div>{{ item2.message }}</div>
                </li>
              </ul>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
import $ from "jquery";
import axios from "axios";
// 引入处理录音文件的js
import Record from "../../assets/js/record-sdk";
//引入token解析包 jwt-decode
import jwt_decode from "jwt-decode";
// 引入星级评语文件
import Info from "../../assets/js/info";
import CorrectDialog from "./components/correctDialog.vue";
import Header from "./header.vue";
import CorrectBox from "./components/correctionBox.vue";

export default {
  data() {
    return {
      role: 2,
      imgName: "img",
      degrees: 0,
      sentenceSolo: "这里是每段的句子，要标红错误的单词",
      // diaClose: false, //控制是否可以通过点击 modal 关闭 Dialog
      identity: "",
      teacherGroup: 0,
      userName: "",
      dataNew: [],
      essay: "",
      essay1: "",
      details: [], //接受后台返回来的数据
      details2: [], //与details数据一样，用来做批改详情错误标记高亮显示操作，避免影响details
      statistics: {},
      correctType: "",
      flag1: false,
      flag2: false,
      deadline: "",
      timenow: "",
      allTime: 0,
      countDown: "", //倒计时
      tags: {
        //侧边导航栏错误类型数量
        allTags: 0,
        allErrs: 0,
        lightspot: 0, // 侧边栏加分项
        cacography: 0,
        syntax: 0,
        semantic: 0,
        pragmatic: 0,
        structure: 0,
        content: 0,
        otherErrs: 0,
        others: 0
      },
      //右侧信息
      word_count: "",
      avg_word_len: "",
      unique_word: "",
      conjunction_word_countN: 0,
      sentence_count: "",
      avg_sentence_len: "",
      sentence_simple_count: "",
      sentence_compound_count: "",
      sentence_complex_count: "",
      sentence_compound_complex_count: "",
      //查看详情按钮
      wordEchartShow: false,
      activeNames: [],
      activeIndex: "",
      pids: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
      strObj: {
        str1: "拼写错误大小写错误缩写错误没有此词拼写错误",
        str2:
          "语法错误搭配错误并列结构错误词性错误连词错误限定词错误数词错误代词错误代词不一致介词错误冠词错误单复数错误所有格错误主谓不一致时态不一致时态错误动词形式错误语态错误比较级使用错误复合句结构错误",
        str3: "语义错误措辞错误意义不明褒贬错误指代不明歧义",
        str4: "语用错误中式英语文化差异口语化",
        str5:
          "结构错误逻辑错误标点错误断句错误不完整句成分多余词序错误语句不通顺语序调换",
        str6: "内容错误内容重复内容不相关",
        str7:
          "高级词汇同义表达多样表达地道句式多样正确名言使用恰当衔接流畅篇章结构清晰论点新颖紧扣主题使用修辞",
        str8: "其他项"
      },
      value: "",
      index: 1,
      dialogVisible: false,
      ruleForm1: {
        errorType: "", //错误类型
        correctContent: "" //修改建议
      },
      rules: {
        errorType: {
          required: true,
          message: "请选择批注类型",
          trigger: "blur"
        },
        correctContent: {
          required: true,
          message: "请输入批改说明",
          trigger: "blur"
        }
      },
      next_idle_error_id: 0, // 猜测是下一个批改信息应该使用的id（初始从0开始）
      tagList: [], // 新建一个问题数组，用来存储所有的问题
      qusObj: {
        id: "", //错误排序
        issueType: "", //批注类型
        offset: "", //起始位置
        length: "", //字符串长度
        message: "" //批改说明
      },
      sub: 0,
      subIndex: "",
      subId: "",
      id: 0,
      baseUrl: "", // 匹配后台地址
      token: "",
      articleId: null,
      // ---------------------------------------------
      isFinished: false,
      audio: "",
      recorder: new Record(),
      recorderStatus: "empty", // empty 初始化等待状态,  Recording  //录音中  complete // 录音完成
      recorderBlob: {}, // 传给后台的录音文件对象
      // ------------------------------------------------
      blobUrl: "", // 接受后台返回来的音频文件的url
      isCover: 0, // 为0时，说明选中文本不包含错误标签
      tabType: "allTags", // 只有当值为 allTags 时才能进行批改操作
      isSubInfo: 0, // 是否显示查看写作要求的按钮 1---true  0---false
      requirements: {
        // 作文写作要求
        // source为1时
        title: "",
        introductions: "",
        pictures: [],
        starts: "",
        examples: [],
        // source为2时
        custom_title: "", // 题干文本内容
        custom_title_img: "", // 题干图片地址
        main_idea: "", // 写作指导文本内容
        main_idea_img: "", // 写作指导图片地址
        hint: "", // 写作范文文本内容
        hint_img: "" // 写作范文图片地址
      },
      videoCode: 0, // 0表示正常，1表示不正常
      recordStatus: 1, // 1---未开始录音 2--录音中 3--录音结束(有录音)
      // hour:0,//定义时，分，秒，毫秒并初始化为0；
      minute: 0,
      second: 0, // 秒
      time: "",
      str: "",
      wordStar: 0,
      sentenceStar: 0,
      structureStar: 0,
      // 星级评价、评语、分数
      ruleForm: {
        comments: {
          //第一维度评价
          word: {
            star: 0,
            text: "",
            subscore: undefined
          },
          //第二维度评价
          sentence: {
            star: 0,
            text: "",
            subscore: undefined
          },
          //第三维度评价
          structure: {
            star: 0,
            text: "",
            subscore: undefined
          },
          tidyScore: 0,
          summary: "" //作文点评
        },
        score: 0
      },
      referenceDialogVisible: false,
      imgList: [],
      // 加载分数、评语下拉框的内容
      scoreObj: {},
      evaluateObj: {},
      sub_type: 0,
      scoreArea: {
        word: undefined,
        sentence: undefined,
        structure: undefined
      },
      evaluate: {
        // 各个参数默认为七年级、0颗星时的数据
        word: {
          comments: [],
          scoreOptions: []
        },
        sentence: {
          comments: [],
          scoreOptions: []
        },
        structure: {
          comments: [],
          scoreOptions: []
        }
      },
      grade: 7, // 表示年级 7--七年级  8--八年级 9--九年级，默认为七年级
      yd_ref_score: {
        majorscore_grammar: 0,
        majorscore_structure: 0,
        majorscore_topic: 0,
        majorscore_word: 0,
        score: 0
      },
      source: 1, // 表示写作要求的来源，可选值为1和2
      // clientL: 0 // 以浏览器窗口左上顶角为原点，定位 x 轴坐标
      dimension: {
        wordName: '词汇运用',
        sentenceName: '语言表达',
        structureName: '篇章结构'
      }
    };
  },
  components: {
    Header,
    CorrectDialog,
    CorrectBox
  },
  created() {
    this.baseUrl = this.GLOBAL.BASE_URL;
    window.repealDetails = this.repealDetails;
    window.editorDetails = this.editorDetails;
  },
  mounted() {
    // 页面初始化时加载拖拽函数
    this.directive();
    this.init();
  },
  methods: {
    init() {
      // 获取token，并解析
      if (localStorage.getItem("token")) {
        // 获取当前账号的角色信息
        this.role = Number(localStorage.getItem("role"));
        let token = jwt_decode(localStorage.getItem("token"));
        // 获取用户信息（用户名和用户身份）
        this.identity = token.identity;
        this.teacherGroup = token.teacher_group;
        this.userName = token.nickname;
        //得到页面跳转带过来的文章信息
        this.id = this.$route.query.id;
        this.activeIndex = this.$route.query.activeIndex;
        home
          .check({ id: this.id, mode: 2 })
          .then(res => {
            if (res.data.retcode === 0) {
              this.id = res.data.data.id;
              this.dataNew = res.data.data;
              //获取当前时间和批改期限
              this.deadline = res.data.data.deadline;
              this.timenow = res.data.data.timenow;
              this.essay = res.data.data.essay_text;
              this.essay1 = res.data.data.essay_text;
              this.details = res.data.data.details;
              this.statistics = res.data.data.statistics;
              this.correctType = res.data.data.correct_mode;
              // 获取作文图片的内容
              if (res.data.data.images) {
                this.imgList = res.data.data.images;
              }
              // 获取AI评分评分结果
              if (res.data.data.yd_ref_score !== null) {
                this.yd_ref_score.majorscore_grammar =
                  res.data.data.yd_ref_score.majorscore_grammar;
                this.yd_ref_score.majorscore_structure =
                  res.data.data.yd_ref_score.majorscore_structure;
                this.yd_ref_score.majorscore_topic =
                  res.data.data.yd_ref_score.majorscore_topic;
                this.yd_ref_score.majorscore_word =
                  res.data.data.yd_ref_score.majorscore_word;
                this.yd_ref_score.score = res.data.data.yd_ref_score.score;
              }
              // 获取年级信息
              this.grade = res.data.data.grade;
              // 根据年级信息定义三个维度
              if (this.grade > 9) {
                if (res.data.data.subject_info) {
                  const type = res.data.data.subject_info.sub_type;
                  this.sub_type = res.data.data.subject_info.sub_type;
                  if (type === 12702) {// 概要写作
                    this.dimension.wordName = '要点';
                    this.dimension.sentenceName = '语言';
                    this.dimension.structureName = '连贯性';
                  } else if (type === 12703) { // 读后续写
                    this.dimension.wordName = '语言';
                    this.dimension.sentenceName = '内容';
                    this.dimension.structureName = '连贯性';
                  } else {
                    this.dimension.wordName = '语言';
                    this.dimension.sentenceName = '内容';
                    this.dimension.structureName = '结构';
                  }
                } else {
                  this.dimension.wordName = '语言';
                  this.dimension.sentenceName = '内容';
                  this.dimension.structureName = '结构';
                  
                }
              };
              // 根据年级信息给每个模块的分数段和评语段赋值
              this.scoreObj = Info.manage(this.grade);
              this.evaluateObj = Info.getEvaluate(this.grade, this.sub_type);
              // 给各个维度分值区域赋值
              this.scoreArea.word = this.scoreObj.word_score[
                this.scoreObj.word_score.length - 1
              ][
                this.scoreObj.word_score[this.scoreObj.word_score.length - 1]
                  .length - 1
              ].value;
              this.scoreArea.sentence = this.scoreObj.expression_score[
                this.scoreObj.expression_score.length - 1
              ][
                this.scoreObj.expression_score[
                  this.scoreObj.expression_score.length - 1
                ].length - 1
              ].value;
              this.scoreArea.structure = this.scoreObj.structure_score[
                this.scoreObj.structure_score.length - 1
              ][
                this.scoreObj.structure_score[
                  this.scoreObj.structure_score.length - 1
                ].length - 1
              ].value;
              // 获取作文试题信息
              if (res.data.data.subject_info) {
                this.isSubInfo = 1;
                this.source = res.data.data.subject_info.source;
                if (this.source === 1) {
                  this.requirements.title = res.data.data.subject_info.title;
                  this.requirements.introductions =
                    res.data.data.subject_info.introductions;
                  this.requirements.starts = res.data.data.subject_info.starts;
                  this.requirements.examples =
                    res.data.data.subject_info.examples;
                  this.requirements.pictures =
                    res.data.data.subject_info.pictures;
                } else {
                  this.requirements.custom_title =
                    res.data.data.subject_info.custom_title;
                  this.requirements.custom_title_img =
                    res.data.data.subject_info.custom_title_img;
                  this.requirements.main_idea =
                    res.data.data.subject_info.main_idea;
                  this.requirements.main_idea_img =
                    res.data.data.subject_info.main_idea_img;
                  this.requirements.hint = res.data.data.subject_info.hint;
                  this.requirements.hint_img =
                    res.data.data.subject_info.hint_img;
                }
              }
              //获取后台数据，重新渲染页面信息
              if (res.data.data.comments) {
                this.ruleForm.score = res.data.data.score;
                this.wordStar = res.data.data.comments.word.star / 2;
                this.ruleForm.comments.word.star =
                  res.data.data.comments.word.star;
                this.ruleForm.comments.word.text =
                  res.data.data.comments.word.text;
                this.ruleForm.comments.word.subscore =
                  res.data.data.comments.word.subscore;
                this.sentenceStar = res.data.data.comments.sentence.star / 2;
                this.ruleForm.comments.sentence.star =
                  res.data.data.comments.sentence.star;
                this.ruleForm.comments.sentence.text =
                  res.data.data.comments.sentence.text;
                this.ruleForm.comments.sentence.subscore =
                  res.data.data.comments.sentence.subscore;
                this.structureStar = res.data.data.comments.structure.star / 2;
                this.ruleForm.comments.structure.star =
                  res.data.data.comments.structure.star;
                this.ruleForm.comments.structure.text =
                  res.data.data.comments.structure.text;
                this.ruleForm.comments.structure.subscore =
                  res.data.data.comments.structure.subscore;
                if (res.data.data.comments.tidyScore) {
                  this.ruleForm.comments.tidyScore =
                    res.data.data.comments.tidyScore;
                }
                this.ruleForm.comments.summary = res.data.data.comments.summary;
                this.blobUrl = res.data.data.speech_file;
                // 根据星级给对应的分数段赋值
                this.evaluate.word.scoreOptions = this.scoreObj.word_score[
                  this.wordStar
                ];
                this.evaluate.sentence.scoreOptions = this.scoreObj.expression_score[
                  this.sentenceStar
                ];
                this.evaluate.structure.scoreOptions = this.scoreObj.structure_score[
                  this.structureStar
                ];
                // 根据星级给对应的评价段赋值
                this.evaluate.word.comments = this.evaluateObj.word_evaluate[this.wordStar];
                this.evaluate.sentence.comments = this.evaluateObj.expression_evaluate[this.sentenceStar];
                this.evaluate.structure.comments = this.evaluateObj.structure_evaluate[this.structureStar];
                $("audio")[0].src = this.blobUrl;
                if (this.blobUrl) {
                  this.isFinished = true;
                  this.recorderStatus = "complete";
                  this.recordStatus = 3;
                } else {
                  this.isFinished = false;
                  this.recorderStatus = "empty";
                }
              } else {
                this.evaluate.word.scoreOptions = this.scoreObj.word_score[0];
                this.evaluate.sentence.scoreOptions = this.scoreObj.expression_score[0];
                this.evaluate.structure.scoreOptions = this.scoreObj.structure_score[0];
                this.evaluate.word.comments = this.evaluateObj.word_evaluate[0];
                this.evaluate.sentence.comments =
                  this.evaluateObj.expression_evaluate[0];
                this.evaluate.structure.comments =
                  this.evaluateObj.structure_evaluate[0];
              }
              for (let i = 0; i < this.details.length; i++) {
                this.activeNames.push(i);
              }
              this.newErr();
              // 获取id最大值
              let idArr = [];
              this.tagList.map(item => {
                idArr.push(item.id);
              });
              if (idArr.length === 0) {
                this.next_idle_error_id = 0;
              } else {
                this.next_idle_error_id = Math.max(...idArr) + 1;
              }
              //右侧信息
              this.rightInfo(this.statistics);
              this.timeDown();
            } else if (res.data.retcode === 1 || res.data.retcode === 2) {
              this.$alert(res.data.retmsg, "登录异常", {
                confirmButtonText: "确定",
                callback: action => {
                  this.clearCache();
                }
              });
            } else {
              this.$alert(res.data.retmsg, "请求失败", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$router.push({ path: `/${this.activeIndex}` });
                }
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "未登录，请重新登录",
          type: "warning",
          duration: 1000,
          onClose: res => {
            this.clearCache();
          }
        });
      }
      this.tabType = "allTags";
      // 控制只可在显示全部错误时才能触发selectMethod方法
      document.onselectstart = function() {
        return true;
      };
    },
    // 各个维度星级评价变化的回调
    wordStarChange(value) {
      this.wordStar = value;
      this.ruleForm.comments.word.star = value * 2;
      this.evaluate.word.comments = this.evaluateObj.word_evaluate[value];
      this.evaluate.word.scoreOptions = this.scoreObj.word_score[value];
      // 星级评价改变时，清空输入框中的分数
      this.ruleForm.comments.word.subscore = this.evaluate.word.scoreOptions[0].value;
      this.scoreChange();
    },
    sentenceStarChange(value) {
      this.sentenceStar = value;
      this.ruleForm.comments.sentence.star = value * 2;
      this.evaluate.sentence.comments =
        this.evaluateObj.expression_evaluate[value];
      this.evaluate.sentence.scoreOptions = this.scoreObj.expression_score[
        value
      ];
      // 星级评价改变时，清空输入框中的分数
      this.ruleForm.comments.sentence.subscore = this.evaluate.sentence.scoreOptions[0].value;
      this.scoreChange();
    },
    structureStarChange(value) {
      this.structureStar = value;
      this.ruleForm.comments.structure.star = value * 2;
      this.evaluate.structure.comments = this.evaluateObj.structure_evaluate[value];
      this.evaluate.structure.scoreOptions = this.scoreObj.structure_score[
        value
      ];
      // 星级评价改变时，清空输入框中的分数
      this.ruleForm.comments.structure.subscore = this.evaluate.structure.scoreOptions[0].value;
      this.scoreChange();
    },
    // 各个维度评语部分下拉选value改变时的回调
    wordSelectChange(value) {
      this.ruleForm.comments.word.text += value + ";" + "\n";
    },
    sentenceSelectChange(value) {
      this.ruleForm.comments.sentence.text += value + ";" + "\n";
    },
    structureSelectChange(value) {
      this.ruleForm.comments.structure.text += value + ";" + "\n";
    },
    scoreChange() {
      this.ruleForm.score =
        (this.ruleForm.comments.word.subscore
          ? Number(this.ruleForm.comments.word.subscore)
          : 0) +
        (this.ruleForm.comments.sentence.subscore
          ? Number(this.ruleForm.comments.sentence.subscore)
          : 0) +
        (this.ruleForm.comments.structure.subscore
          ? Number(this.ruleForm.comments.structure.subscore)
          : 0) +
        Number(this.ruleForm.comments.tidyScore);
      if (this.ruleForm.score < 0) {
        this.ruleForm.score = 0;
      }
    },
    // 自定义弹框拖拽函数
    directive() {
      let drag = $("#drag")[0];
      drag.onmousedown = function(event) {
        var event = event || window.event; //兼容IE浏览器
        //    鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
        var diffX = event.clientX - drag.offsetLeft;
        var diffY = event.clientY - drag.offsetTop;
        if (typeof drag.setCapture !== "undefined") {
          drag.setCapture();
        }
        document.onmousemove = function(event) {
          var event = event || window.event;
          var moveX = event.clientX - diffX;
          var moveY = event.clientY - diffY;
          if (moveX < 0) {
            moveX = 0;
          } else if (moveX > window.innerWidth - drag.offsetWidth) {
            moveX = window.innerWidth - drag.offsetWidth;
          }
          if (moveY < 0) {
            moveY = 0;
          } else if (moveY > window.innerHeight - drag.offsetHeight) {
            moveY = window.innerHeight - drag.offsetHeight;
          }
          drag.style.left = moveX + "px";
          drag.style.top = moveY + "px";
        };
        document.onmouseup = function(event) {
          this.onmousemove = null;
          this.onmouseup = null;
          //修复低版本ie bug
          if (typeof drag.releaseCapture != "undefined") {
            drag.releaseCapture();
          }
        };
      };
    },
    // '查看写作说明'按钮的回调
    openDialog() {
      $("#drag")[0].style.display = "inline";
    },
    // 关闭写作要求模态框的回调
    closeDialog() {
      // 关闭对话框前先将滚动条移动到默认的起始位置
      $(".title_cover").scrollTop(0);
      $("#drag")[0].style.display = "none";
    },
    // 暂存按钮和保存按钮点击事件
    cache(a) {
      if (this.recordStatus === 2) {
        // alert('录音中')
        this.$confirm("录音中，是否停止录音？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.play();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消！"
            });
          });
      } else {
        // 提交
        if (a === 0) {
          if (this.correctType === 3) {
            // 精批时所有项必填
            if (!this.ruleForm.comments.word.text) {
              this.$alert(`请对本文的${this.dimension.wordName}给予评价！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (this.ruleForm.comments.word.subscore === undefined) {
              this.$alert(`请为本文的${this.dimension.wordName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (!this.ruleForm.comments.sentence.text) {
              this.$alert(`请对本文的${this.dimension.sentenceName}给予评价！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (this.ruleForm.comments.sentence.subscore === undefined) {
              this.$alert(`请为本文的${this.dimension.sentenceName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (!this.ruleForm.comments.structure.text) {
              this.$alert(`请对本文的${this.dimension.structureName}给予评价！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (
              this.ruleForm.comments.structure.subscore === undefined
            ) {
              this.$alert(`请为本文的${this.dimension.structureName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (!this.ruleForm.comments.summary) {
              this.$alert("请为本文做最终点评！", "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else {
              // 各个维度为0颗星时添加提示信息
              if (this.wordStar === 0) {
                this.$confirm(
                  `${this.dimension.wordName}为${this.wordStar}颗星,提交后不可更改，是否继续？`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }
                )
                  .then(() => {
                    // 第一维度为0星且提示后依旧提交时检查第二维度是否为0星
                    if (this.sentenceStar === 0) {
                      this.$confirm(
                        `${this.dimension.sentenceName}为${
                          this.sentenceStar
                        }颗星,提交后不可更改，是否继续？`,
                        "提示",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning"
                        }
                      )
                        .then(() => {
                          // 第一维度和第二维度皆为0星且依旧提交时检查第三维度是否为0星
                          if (this.structureStar === 0) {
                            this.$confirm(
                              `${this.dimension.structureName}为${
                                this.structureStar
                              }颗星,提交后不可更改，是否继续？`,
                              "提示",
                              {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning"
                              }
                            )
                              .then(() => {
                                this.save(a);
                              })
                              .catch(() => {
                                this.$message({
                                  type: "info",
                                  message: "已取消提交"
                                });
                              });
                          } else {
                            this.save(a);
                          }
                        })
                        .catch(() => {
                          this.$message({
                            type: "info",
                            message: "已取消提交"
                          });
                        });
                    } else if (this.structureStar === 0) {
                      this.$confirm(
                        `${this.dimension.structureName}为${
                          this.structureStar
                        }颗星,提交后不可更改，是否继续？`,
                        "提示",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning"
                        }
                      )
                        .then(() => {
                          this.save(a);
                        })
                        .catch(() => {
                          this.$message({
                            type: "info",
                            message: "已取消提交"
                          });
                        });
                    } else {
                      this.save(a);
                    }
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消提交"
                    });
                  });
              } else if (this.sentenceStar === 0) {
                this.$confirm(
                  `${this.dimension.sentenceName}为${
                    this.sentenceStar
                  }颗星,提交后不可更改，是否继续？`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }
                )
                  .then(() => {
                    // 第二维度为0星时检查第三维度是否为0星
                    if (this.structureStar === 0) {
                      this.$confirm(
                        `${this.dimension.structureName}为${
                          this.structureStar
                        }颗星,提交后不可更改，是否继续？`,
                        "提示",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning"
                        }
                      )
                        .then(() => {
                          this.save(a);
                        })
                        .catch(() => {
                          this.$message({
                            type: "info",
                            message: "已取消提交"
                          });
                        });
                    } else {
                      this.save(a);
                    }
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消提交"
                    });
                  });
              } else if (this.structureStar === 0) {
                this.$confirm(
                  `${this.dimension.structureName}为${
                    this.structureStar
                  }颗星,提交后不可更改，是否继续？`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }
                )
                  .then(() => {
                    this.save(a);
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消提交"
                    });
                  });
              } else {
                this.$confirm("提交后不可更改，是否继续？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                    this.save(a);
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消提交"
                    });
                  });
              }
            }
          } else {
            // 粗批时分数段必填
            if (this.ruleForm.comments.word.subscore === undefined) {
              this.$alert(`请为本文的${this.dimension.wordName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (this.ruleForm.comments.sentence.subscore === undefined) {
              this.$alert(`请为本文的${this.dimension.sentenceName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else if (
              this.ruleForm.comments.structure.subscore === undefined
            ) {
              this.$alert(`请为本文的${this.dimension.structureName}打分！`, "提交前确认", {
                confirmButtonText: "确定",
                closeOnClickModal: true,
                callback: res => {}
              });
            } else {
              this.$confirm(
                `本次打分：${
                  this.ruleForm.score
                }分，提交后不可更改，是否继续？`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              )
                .then(() => {
                  this.save(a);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消提交"
                  });
                });
            }
          }
        }
        // 暂存
        if (a === 1) {
          this.save(a);
        }
      }
    },
    // 暂存和保存接口
    save(a) {
      let data = new FormData();
      data.append("id", this.id);
      data.append("questions", JSON.stringify(this.tagList));
      data.append("comments", JSON.stringify(this.ruleForm.comments));
      if (this.ruleForm.score || this.ruleForm.score === 0) {
        data.append("score", this.ruleForm.score);
      } else {
        data.append("score", "");
      }
      data.append("temporary", a);
      if (this.recorderBlob && this.recorderBlob.size) {
        data.append("speechFile", this.recorderBlob, "recorder.wav");
      } else {
        data.append("speechFile", this.blobUrl);
      }
      let token = localStorage.getItem("token");
      $.ajax({
        url: this.baseUrl + "correct_result/",
        headers: { Authorization: token },
        type: "post",
        dataType: "json",
        contentType: false,
        processData: false,
        data: data,
        success: res => {
          if (res.retcode === 0) {
            this.$message({
              message: res.retmsg,
              type: "success",
              duration: 2000
            });
            if (a === 0) {
              setTimeout(() => {
                this.$router.push({ path: "myTasks" });
              }, 2000);
            }
          } else if (res.retcode === 1 || res.retcode === 2) {
            this.$alert(res.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: action => {
                this.clearCache();
              }
            });
          } else {
            this.$alert(res.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        },
        error(err) {
          console.log(333, err);
        }
      });
      // 将recorderBlob的值清空，避免影响下次使用
      this.recorderBlob = {};
    },
    // 倒计时
    timeDown() {
      //获得批改时限
      this.allTime = Date.parse(this.deadline) - Date.parse(this.timenow);
      if (this.allTime > 0) {
        let t1 = setInterval(() => {
          let day = Math.floor(this.allTime / (24 * 60 * 60 * 1000));
          let hour = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000) / (60 * 60 * 1000)
          );
          let minute = Math.floor(
            (this.allTime - day * 24 * 60 * 60 * 1000 - hour * 60 * 60 * 1000) /
              (60 * 1000)
          );
          let second = Math.floor(
            (this.allTime -
              day * 24 * 60 * 60 * 1000 -
              hour * 60 * 60 * 1000 -
              minute * 60 * 1000) /
              1000
          );
          hour = day * 24 + hour;
          if (hour < 10) {
            hour = "0" + hour;
          }
          if (minute < 10) {
            minute = "0" + minute;
          }
          if (second < 10) {
            second = "0" + second;
          }
          this.countDown =
            "剩余时间  " + hour + " : " + minute + " : " + second;
          this.allTime -= 1000;
          // 倒计时归零时清楚定时器
          if (this.allTime === 0) {
            clearInterval(t1);
            this.countDown = "任务已超时，请及时处理";
          }
        }, 1000);
      } else {
        this.countDown = "任务已超时，请及时处理";
      }
    },
    //遍历原数组中的所有错误信息存储在新数组
    newErr() {
      let data = this.dataNew;
      let arr = [];
      for (let i = data.details.length - 1; i >= 0; i--) {
        for (let j = data.details[i].sentences.length - 1; j >= 0; j--) {
          data.details[i].sentences[j].sentenceSolo = this.essay.substr(
            data.details[i].sentences[j].sentence.offset,
            data.details[i].sentences[j].sentence.length
          );
          for (
            let z = data.details[i].sentences[j].questions.length - 1;
            z >= 0;
            z--
          ) {
            let item = data.details[i].sentences[j].questions[z];
            this.tagList.push(item);
            arr.push(item.issueType);
          }
        }
      }
      for (let n = 0; n < arr.length; n++) {
        // let str = arr[n].split('/')[arr[n].split('/').length-1];---这一步是做处理把错误类型只显示最后一级
        let str = arr[n];
        this.tagList[n].issueType = str;
      }
      this.errorTagging();
    },
    //倒序函数
    reverseList() {
      let arr = [];
      this.tagList.map(item => {
        arr.unshift(item);
      });
      return arr;
    },
    //遍历错误单词标注
    errorTagging() {
      this.essay = this.essay1;
      let html = this.essay;
      this.tagList.map(item => {
        let html1 = html.split(""); //字符串转为数组
        let displayMessage = "block";
        if (!item.message) {
          displayMessage = "none";
        }
        let tagName = "";
        let str = item.issueType;
        if (str.indexOf("加分项") >= 0) {
          tagName += "lightspot ";
        } else if (str.indexOf("其他项") >= 0) {
          tagName += "others";
        } else {
          tagName += "allErrs ";
          if (str.indexOf("拼写错误") >= 0) {
            tagName += "cacography";
          } else if (str.indexOf("语法错误") >= 0) {
            tagName += "syntax";
          } else if (str.indexOf("语义错误") >= 0) {
            tagName += "semantic";
          } else if (str.indexOf("语用错误") >= 0) {
            tagName += "pragmatic";
          } else if (str.indexOf("结构错误") >= 0) {
            tagName += "structure";
          } else if (str.indexOf("内容错误") >= 0) {
            tagName += "content";
          } else {
            tagName += "otherErrs";
          }
        }
        html1.splice(
          item.offset,
          item.length,
          `<div class="wrap"><span class="` +
            tagName +
            // ' show" style="flex:8"><em class="comment_em">&nbsp;</em><errorWords>' +
            // this.essay.substr(item.offset, item.length) +
            // '</errorWords></span><div class="error_mark"><ul><li><div style="width:65px;display:inline-block;">批注类型：</div>' +

            ' show" style="flex:8"><span><em class="comment_em">&nbsp;</em></span><errorWords><xmp style="display:inline-block;margin:0;">' +
            this.essay.substr(item.offset, item.length) +
            '</xmp></errorWords></span><div class="error_mark"><ul><li><div style="width:65px;display:inline-block;">批注类型：</div>' +
            str +
            '</li><li style="display:' +
            displayMessage +
            '"><div style="display:flex;"><div style="width:65px;height:60px;line-height:20px;">批改说明：</div><div word-break:keep-all;">' +
            item.message +
            '</div></div></li></ul><button  class="wrap_btn1" onclick = "repealDetails(' +
            item.id +
            ')">撤销</button> <button  class="wrap_btn2" onclick = "editorDetails(' +
            item.id +
            ')">编辑</button></div></div>'
        );
        html = html1.join("");
      });
      this.essay = html.replace(/\n/g, "<br>");
      this.$nextTick(() => {
        let spanDoms = $(".comment_em");
        for (let i = 0; i < spanDoms.length; i++) {
          $(spanDoms[i]).html(i + 1);
        }
        this.errorDetails(); //悬浮在指定错误处显示错误详情
        this.errorCategory(); //侧边栏显示批注类别数量
        this.errorSign();
      });
    },
    //标红每句中的错误信息
    errorSign() {
      // 只有精批的时候才会调用
      // if( this.correctType === 3 ){
      let details = this.details;
      for (let i = details.length - 1; i >= 0; i--) {
        for (let j = details[i].sentences.length - 1; j >= 0; j--) {
          let startOffset = details[i].sentences[j].sentence.offset;
          let sentenceLength = details[i].sentences[j].sentence.length;
          //错误详情展示下的每个独立句子
          details[i].sentences[j].sentenceSolo = this.dataNew.essay_text.substr(
            startOffset,
            sentenceLength
          );
          this.tagList.map(item => {
            if (
              item.offset >= startOffset &&
              item.offset < startOffset + sentenceLength
            ) {
              details[i].sentences[j].sentenceSolo1 = details[i].sentences[
                j
              ].sentenceSolo.split("");
              let reg = /^加分项.*/;
              let reg2 = /^扣分项.*/;
              if (reg.test(item.issueType)) {
                details[i].sentences[j].sentenceSolo1.splice(
                  item.offset - startOffset,
                  item.length,
                  "<errorLabel style='color: #3db95c;font-weight:bolder;'><xmp style='display:inline-block;margin:0;'>" +
                    this.essay1.substr(item.offset, item.length) +
                    "</xmp></errorLabel>"
                );
              } else if (reg2.test(item.issueType)) {
                details[i].sentences[j].sentenceSolo1.splice(
                  item.offset - startOffset,
                  item.length,
                  "<errorLabel style='color: #fc500d;font-weight:bolder;'><xmp style='display:inline-block;margin:0;'>" +
                    this.essay1.substr(item.offset, item.length) +
                    "</xmp></errorLabel>"
                );
              } else {
                details[i].sentences[j].sentenceSolo1.splice(
                  item.offset - startOffset,
                  item.length,
                  "<errorLabel style='color: #5e79fd;font-weight:bolder;'><xmp style='display:inline-block;margin:0;'>" +
                    this.essay1.substr(item.offset, item.length) +
                    "</xmp></errorLabel>"
                );
              }
              details[i].sentences[j].sentenceSolo = details[i].sentences[
                j
              ].sentenceSolo1.join("");
            }
          });
        }
      }
      this.details2 = details;
      // };
    },
    //鼠标选中文本批改事件
    selectMethod() {
      // 第一步：获取用户选择的文本范围
      let selected = window.getSelection(); // 返回一个Selection对象，表示用户选择的文本范围或光标的当前位置。
      let str = selected.toString();        // 获取选中文本
      // 有选中的内容时才进行以下操作
      if(str){
        // 第二步：判断选中文本是否包含已批注内容、是否跨段选中
        let atr = selected.getRangeAt(0).cloneContents(); // selected.getRangeAt()返回一个Range表示当前选定范围之一的对象 cloneContents() 方法把范围（Range）的内容复制到一个 DocumentFragment 对象。
        let testDiv = document.createElement("div");
        testDiv.appendChild(atr);
        let selectHtml = testDiv.innerHTML;
        let reg = /[\n]/;
        let labelReg = /<[^div class=\"wrap\"]+>/g;
        // 不允许包含错误标记
        if (labelReg.test(selectHtml) === true) {
          // 取消选中文本
          window.getSelection && window.getSelection().removeAllRanges();
          // this.isCover = 0;
          this.$message({
            message: "选中的文本中已有批注，请重新选择！",
            type: "error",
            duration: 2000,
            onClose: res => {}
          });
          // 不允许跨段选中 不允许覆盖原错误标注
        } else if (reg.test(str) === true) {
          // 取消选中文本
          window.getSelection && window.getSelection().removeAllRanges();
          this.$message({
            message: "请勿跨段选中文本，请重新选择！",
            type: "error",
            duration: 2000,
            onClose: res => {}
          });
          this.isCover = 0;
        } else {
          // 有选中文本且在‘所有批注’状态下时才允许执行操作
          if (this.tabType === "allTags" && str) {
            // 修改目前的模式为'添加新批注'
            this.sub = 0;
            // 选中文本后为qusObj中的id，length属性赋值
            this.qusObj.id = this.next_idle_error_id;
            this.qusObj.length = str.length;
            // 第三步：将文中选中部分的文本用标签表示
            let range = selected.getRangeAt(0); // 返回一个Range表示当前选定范围之一的对象
            let xe = document.createElement("span");
            xe.className = "newTag";
            range.surroundContents(xe); // 将 内容移动 Range到新节点中，将新节点放置在指定范围的开头。(用元素包裹选中文本)
            // 第四步：获取当前文本内容m (包含所有带标签的文本和上一步创建的新标签),替换所有带标签的文本为纯文本，只保留新标签
            let m = $(".content")[0].innerHTML.replace(/<br>/g, "\n"); // m的值可能会有问题，出现特殊字符时会被转义，m的长度会受影响，从而影响标记在m中的位置
            let elem = document.getElementsByTagName("errorWords");
            for (let index = 0; index < elem.length; index++) {
              let el = $(".wrap"); //得到所有的错误标签及其内容
              m = m.replace(el[index].outerHTML, elem[index].innerText);
            }
            // 第五步：用自定义占位文本替换上一步新标签，并将其作为新元素span的内容(此时newValue的值为——特殊字符被转义且代表新标签的'TTTTT'文本)
            let newValue = m.replace($(".newTag")[0].outerHTML, 'TTTTT');
            let newElem = document.createElement("span");
            // newElem.innerHTML = newValue;
            newElem.innerText = newValue;
            // 第六步：还原被转义的字符同时获取span标签纯文本内容，此时'TTTTT'文本的位置即为新添标记在原文中的位置w1
            // let txt = newElem.innerText;
            // let w1 = txt.indexOf('TTTTT');
            let w1 = newValue.indexOf('TTTTT');
            this.qusObj.offset = w1;
            let newLength = str.length;
            // 得到选中文本在原文中的offset后先把newTag标签去掉
            $(".content")[0].innerHTML = this.essay.replace(
              $(".newTag")[0].outerHTML,
              str
            );
            // 确定所有错误是否跨段选中
            let details = this.details;
            for (let i = details.length - 1; i >= 0; i--) {
              for (let j = details[i].sentences.length - 1; j >= 0; j--) {
                let startOffset = details[i].sentences[j].sentence.offset;
                let sentenceLength = details[i].sentences[j].sentence.length;
                if (
                  w1 >= startOffset &&
                  w1 + newLength <= startOffset + sentenceLength
                ) {
                  this.dialogVisible = true;
                  break;
                }
              }
            }
            if (this.dialogVisible === false) {
              this.$message({
                message: "请勿跨句选中文本，请重新选择！",
                type: "error",
                duration: 2000,
                onClose: res => {}
              });
            }
          }
        }
      };
      this.errorTagging();
    },
    // 弹出框确定按钮绑定事件
    handleSubmit(value1, value2) {
      let str = value1;
      //判断弹窗是编辑原错误
      if (this.sub === 1) {
        // 更新tagList数组数据并重新渲染左侧错误信息栏
        if (this.strObj.str7.indexOf(`${str}`) >= 0) {
          this.tagList[this.subIndex].issueType = "加分项/" + str;
        } else if (this.strObj.str8.indexOf(`${str}`) >= 0) {
          this.tagList[this.subIndex].issueType = "其他项";
        } else {
          if (this.strObj.str1.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/拼写错误/" + str;
          } else if (this.strObj.str2.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/语法错误/" + str;
          } else if (this.strObj.str3.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/语义错误/" + str;
          } else if (this.strObj.str4.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/语用错误/" + str;
          } else if (this.strObj.str5.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/结构错误/" + str;
          } else if (this.strObj.str6.indexOf(`${str}`) >= 0) {
            this.tagList[this.subIndex].issueType = "扣分项/内容错误/" + str;
          } else {
            this.tagList[this.subIndex].issueType = "扣分项/其他错误";
          }
        }
        // this.tagList[this.subIndex].issueType = str;
        this.tagList[this.subIndex].message = value2
          .split("\n")
          .join(" ")
          .split("<")
          .join("");
        this.subIndex = "";
        this.errorCategory();
        this.subId = "";
      }
      //判断弹窗是新添错误
      if (this.sub === 0) {
        if (this.strObj.str7.indexOf(`${str}`) >= 0) {
          this.qusObj.issueType = "加分项/" + str;
        } else if (this.strObj.str8.indexOf(`${str}`) >= 0) {
          this.qusObj.issueType = "其他项";
        } else {
          if (this.strObj.str1.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/拼写错误/" + str;
          } else if (this.strObj.str2.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/语法错误/" + str;
          } else if (this.strObj.str3.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/语义错误/" + str;
          } else if (this.strObj.str4.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/语用错误/" + str;
          } else if (this.strObj.str5.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/结构错误/" + str;
          } else if (this.strObj.str6.indexOf(`${str}`) >= 0) {
            this.qusObj.issueType = "扣分项/内容错误/" + str;
          } else {
            this.qusObj.issueType = "扣分项/其他错误";
          }
        }
        this.qusObj.message = value2
          .split("\n")
          .join(" ")
          .split("<")
          .join("");
        // 先判断tagList是否为空
        if (
          this.tagList.length === 0 ||
          this.tagList[this.tagList.length - 1].offset > this.qusObj.offset
        ) {
          this.tagList.push(this.qusObj);
        } else {
          //将新错误信息的offset与原数据的offset挨个比较，在相应的位置加入新数据
          for (let i = 0; i < this.tagList.length; i++) {
            if (this.tagList[i].offset < this.qusObj.offset) {
              this.tagList.splice(i, 0, this.qusObj);
              break;
            }
          }
        }
        this.qusObj = {
          id: "",
          issueType: "",
          offset: "",
          length: "",
          message: ""
        };
        // //在选中文本前加序号
        // let b = $(".wrapColor" + this.tags.allTags).text();
        // let c = $(".wrapColor" + this.tags.allTags).text(this.tags.allTags + b);
        // $(".wrapColor" + this.tags.allTags).css({ "background-color": "goldenrod" });
        this.tags.allTags++;
      }
      this.errorTagging(); //tagList数组发生变化，两个函数重新调用
      this.sub = 0;
      this.next_idle_error_id++;
    },
    // 弹框关闭前的回调
    handleClose() {
      this.dialogVisible = false;
    },
    //计算鼠标在盒子中的位置
    evfun(event) {
      event = event || window.event;
      let clientL = {
        clientX: event.screenX,
        clientY: event.clientY
      };
      // console.log(123,event,window.scrollY)
      return clientL;
    },
    //悬浮框显示错误详情
    errorDetails(event) {
      this.$nextTick(() => {
        let _that = this;
        $(".content span").bind({
          mouseenter: function(e) {
            let reg = /</;
            if (reg.test(e.target.innerHTML) === false) {
              let x = _that.evfun();
              $(".error_mark").hide();
              // 显示全部错误或者单类错误时对应的弹窗展示
              if (
                _that.tabType === "allTags" ||
                $(e.target)
                  .parent().parent()
                  .hasClass(_that.tabType)
              ) {
                $(e.target)
                  .parent()
                  .parent().parent()
                  .find(".error_mark")
                  .show();
                  // window.screen.width屏幕的宽  window.scrollY:滚动条滚动的距离
                  if(x.clientX > window.screen.width/2){
                    $(e.target)
                    .parent()
                    .parent().parent()
                    .find(".error_mark")[0].style.right = 0;
                  }
                if (x.clientY + 150 + window.scrollY > 475) {
                  $(e.target)
                    .parent()
                    .parent().parent()
                    .find(".error_mark")[0].style.top = `${-142}px`;
                } else {
                  $(e.target)
                    .parent()
                    .parent().parent()
                    .find(".error_mark")[0].style.top = `${30}px`;
                }
              }
            }
          }
        });
        $(".wrap").bind({
          mouseleave: function(e) {
            $(e.target)
              .parent()
              .parent().parent()
              .find(".error_mark")
              .hide();
          }
        });
      });
    },
    //点击编辑按钮，重新编辑错误信息
    editorDetails(id) {
      //只有在批改类型为精批且在导航栏选中'所有批注'时才能进行此类操作
      // this.correctType === 3 &&  ---去掉对粗精批的判断
      if (this.tabType === "allTags") {
        this.dialogVisible = true;
        this.sub = 1;
        this.subId = id;
        for (let i = 0; i < this.tagList.length; i++) {
          if (this.tagList[i].id === id) {
            this.$refs.c1.handleChange(
              this.tagList[i].issueType.split("/")[0],
              this.tagList[i].issueType.split("/")[1],
              this.tagList[i].issueType.split("/")[
                this.tagList[i].issueType.split("/").length - 1
              ],
              this.tagList[i].message
            );
            this.subIndex = i;
          }
        }
      }
    },
    //点击撤销按钮，删除该处系统错误标注
    repealDetails(id) {
      //只有在批改类型为精批且在导航栏选中'所有批注'时才能进行此类操作
      // this.correctType === 3 &&  ---去掉对粗精批的判断
      if (this.tabType === "allTags") {
        for (let i = 0; i < this.tagList.length; i++) {
          if (this.tagList[i].id === id) {
            this.tagList.splice(i, 1);
          }
        }
        this.errorTagging();
      }
    },
    //侧边导航栏切换展示不同类型的批注信息
    handleSelect(key) {
      this.tabType = key;
      //点击“所有批注”时展示所有批注
      if (key === "allTags" || key === undefined) {
        $(".content span")
          .removeClass("hide")
          .addClass("show");
        let spanDoms = $(".show .comment_em");
        for (let i = 0; i < spanDoms.length; i++) {
          $(spanDoms[i]).html(i + 1);
        }
        this.flag2 = false;
        // 控制只可在显示全部错误时才能触发selectMethod方法
        document.onselectstart = function() {
          return true;
        };
      } else {
        //点击侧边导航栏的不同错误分类显示相应错误标注
        $(".content span")
          .removeClass("show")
          .addClass("hide");
        for (let i = 0; i < $(".content span").length; i++)
          if ($(".content span:eq(" + i + ")").hasClass(key)) {
            $(".content span:eq(" + i + ")")
              .removeClass("hide")
              .addClass("show");
          }
        this.flag2 = true;
        // 控制只可在显示全部错误时才能触发selectMethod方法
        document.onselectstart = function() {
          return false;
        };
      }
    },
    //侧边导航栏显示错误类型个数
    errorCategory() {
      //渲染数据之前先将员数组数据清空
      this.tags = {
        allTags: 0,
        allErrs: 0,
        lightspot: 0,
        cacography: 0,
        syntax: 0,
        semantic: 0,
        pragmatic: 0,
        structure: 0,
        content: 0,
        otherErrs: 0,
        others: 0
      };
      this.tags.allTags = this.tagList.length;
      this.tagList.map(item => {
        let str = item.issueType;
        if (str.indexOf("加分项") >= 0) {
          this.tags.lightspot++;
        } else if (str.indexOf("其他项") >= 0) {
          this.tags.others++;
        } else {
          this.tags.allErrs++;
          if (str.indexOf("拼写错误") >= 0) {
            this.tags.cacography++;
          } else if (str.indexOf("语法错误") >= 0) {
            this.tags.syntax++;
          } else if (str.indexOf("语义错误") >= 0) {
            this.tags.semantic++;
          } else if (str.indexOf("语用错误") >= 0) {
            this.tags.pragmatic++;
          } else if (str.indexOf("结构错误") >= 0) {
            this.tags.structure++;
          } else if (str.indexOf("内容错误") >= 0) {
            this.tags.content++;
          } else {
            this.tags.otherErrs++;
          }
        }
      });
    },
    //右侧单词句子量信息
    rightInfo(data) {
      this.word_count = data.word_count;
      this.avg_word_len = data.avg_word_len;
      this.unique_word = data.unique_word;
      this.sentence_count = data.sentence_count;
      this.avg_sentence_len = data.avg_sentence_len;
      this.sentence_simple_count = data.sentence_simple_count;
      this.sentence_compound_count = data.sentence_compound_count;
      this.sentence_complex_count = data.sentence_complex_count;
      this.sentence_compound_complex_count =
        data.sentence_compound_complex_count;
      data.conjunction_word_count.map(item => {
        this.conjunction_word_countN = this.conjunction_word_countN + item;
      });
    },
    // 弹窗dialog
    conceal(type) {
      this.dialogVisible = false;
      this.wordEchartShow = false;
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    },
    //录音开始、停止、删除功能的回调
    startRecord: function(a) {
      // a=0:开始录音  a=1:重新录音
      // 使用录音功能前先判断浏览器内容--只支持chorme、火狐和360极速模式
      var sBrowser = null;
      var sUsrAg = window.navigator.userAgent;
      // The order matters here, and this may report false positives for unlisted browsers.
      if (sUsrAg.indexOf("Firefox") > -1 || sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Mozilla Firefox";
        // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
        // 录音前判断下是否有后台返回的语音文件，如果有，先删除
        if (this.blobUrl) {
          this.blobUrl = "";
        }
        navigator.getUserMedia(
          { audio: true },
          res => {
            let that = this;
            that.recorder.startRecord();
            this.recordStatus = 2;
            this.recorderStatus = "Recording";
            that.isFinished = false;
            if (a === 0) {
              this.timeStart();
            } else {
              this.reset();
              this.timeStart();
            }
          },
          err => {
            this.$message({
              type: "error",
              message: "无法打开麦克风,录音失败!",
              duration: 2000
            });
          }
        );
      } else {
        sBrowser = "unknown";
        this.$message({
          type: "error",
          message: "该浏览器不支持录音功能，请更换浏览器！",
          duration: 2000
        });
      }
    },
    play: function() {
      this.recorderStatus = "complete";
      this.recordStatus = 3;
      let that = this;
      that.isFinished = true;
      that.audio = document.querySelector("audio");
      this.recorderBlob = that.recorder.play(that.audio);
      clearInterval(this.time);
    },
    clear: function() {
      this.recorderBlob = {};
      this.blobUrl = "";
      this.recorderStatus = "empty";
      this.$confirm("此操作将永久删除该录音文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          that.recorder.clear({
            success: res => {
              //此处可以获取音频源文件(res)，用于上传等操作
              console.log("clear successfully.");
            },
            error: res => {
              console.log("clear failed.");
            }
          });
          this.recordStatus = 1;
          that.isFinished = false;
          that.audio = document.querySelector("audio");
          that.audio.src = "";
          that.audio = "";
          this.reset();
          this.$message({
            type: "success",
            message: "删除成功!",
            duration: 2000
          });
        })
        .catch(() => {
          this.recorderStatus = "complete";
          this.$message({
            type: "info",
            message: "已取消删除",
            duration: 2000
          });
        });
    },
    // 计时器开始计时
    timeStart() {
      this.time = setInterval(this.timer, 1000);
    },
    // 计时器
    timer() {
      this.second = this.second + 1;
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1; //分钟
      }
      if (this.minute === 10) {
        clearInterval(this.time);
        setTimeout(() => {
          this.play();
        }, 1000);
      }
      this.str = this.toDub(this.minute) + " ：" + this.toDub(this.second);
    },
    toDub(n) {
      //补0操作
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    },
    // 计时器暂停
    stop() {
      clearInterval(this.time);
    },
    // 计时器重置
    reset() {
      //重置
      clearInterval(this.time);
      this.hour = 0;
      this.minute = 0;
      this.second = 0;
      this.str = "00 ：00";
    }
  }
};
</script>
<style>
/* 针对人工批注内容悬浮撤销框 */
.wrap {
  display: inline-block;
  position: relative;
  user-select: none;
}
.wrap .comment_em {
  text-decoration: none;
  display: inline-block;
  background-color: #fc500d;
  line-height: 8px;
  color: #fff;
  padding: 6px;
  font-family: "Times New Roman", Times, serif;
}
.wrap .lightspot .comment_em {
  background-color: #3db95c;
}
.wrap .others .comment_em {
  background-color: #5e79fd;
}
.wrap .others errorWords {
  color: #5e79fd;
}
.wrap .lightspot errorWords {
  color: #3db95c;
}
.errorWords {
  color: #fc500d;
}
.wrap_btn1 {
  margin: 0 50px 0 25px;
}
.wrap_btn1,
.wrap_btn2 {
  width: 70px;
  height: 35px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 6px 10px;
  font-size: 12px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.error_mark {
  position: absolute;
  top: 35px;
  flex: 3;
  width: 300px;
  height: 150px;
  display: none;
  z-index: 1000;
  background-color: #000;
  padding: 5px 25px 20px;
  line-height: 30px;
  color: #fff;
  font-size: 12px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.error_mark ul {
  padding: 0;
}
.error_mark ul li {
  word-break: break-all;
  word-wrap: break-word;
  list-style: none;
  width: 250px;
}
.error_mark ul li div div:nth-child(2) {
  width: 200px;
  height: 60px;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
/* 导航栏切换批注类别显示隐藏相应错误单词 */
.show em {
  display: inline;
}
.show errorWords {
  color: #fc500d;
}
.hide em {
  display: none !important;
}
.wrap .hide errorWords {
  color: #727388;
}
#textp {
  width: 1320px;margin:0 auto 22px;
  /* width: 100%; */
  height: 65px;
  display: flex;
  background: #d9d9d9;
}
#textp div:nth-child(1) {
  width:250px;
  text-align: center;
  line-height: 45px;
  font-size: 15px;
}
#textp div:nth-child(1) span {
  font-weight: bolder;
}
#textp div:nth-child(1) span:nth-child(3) {
  color: #2593fc;
}
/* 倒计时 */
#textp div:nth-child(2) {
  width: 870px;
  height: 45px;
  color: #f56c6c;
  font-size: 25px;
  text-align: center;
  font-weight: 700;
  letter-spacing: 2px;
}
.score_input {
  width: 100px;
}
textarea {
  text-align: justify;
}
.star {
  display: inline-block !important;
  padding-left: 10px;
}
.dialog_correct {
  height: 668px !important;
}
.dialog_select {
  margin-bottom: 30px;
}
.dialog_select .el-form-item__error,
.dialog_textarea .el-form-item__error {
  margin-left: 16px;
  margin-top: 6px;
}
.dialog-body {
  width: 100%;
}
.dialog-body .el-textarea {
  margin-left: 3%;
  width: 93%;
}
.dialog-footer {
  margin-top: 10px;
  width: 100%;
}
.dialog-footer button:nth-child(2) {
  margin-left: 65px;
}
.el-radio__input {
  display: none;
}
.el-select-dropdown__wrap {
  max-height: 600px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.el-carousel__item h3 {
  /* color: #475669; */
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.medium {
  width: 100%;
  height: 600px;
  overflow: auto;
}

.score_radio .el-radio-button__inner {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  line-height: 30px;
  font-size: 16px;
  border-left: 1px solid #DCDFE6;
}
.clean_style .el-radio-button:last-child .el-radio-button__inner,
.clean_style .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 50px;
}
.other_option .el-radio__label {
  display: inline-block;
  font-size: 16px;
}
/*控制图片放大后的遮罩层的显示范围  */
.correctFrame .el-image-viewer__wrapper {
  width: 60%;
  margin: 0 20%;
}
/* 控制图片放大后的遮罩层大小 */
.correctFrame .el-image-viewer__mask { 
  width: 0;
}
/* 控制图片放大后的遮罩层关闭按钮的颜色和位置 */
.correctFrame .el-image-viewer__close {
  top: 80px;
  color: #409eff;
}
</style>
<style scoped>
.clean_style {
  height: 175px;
  border: 1px solid #e0e3e9;
  display: flex;
}
.menu_first {
  margin-left: 17px;
  height: 50px;
  line-height: 50px;
}
.menu_style {
  width:245px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.middle_content {
  display: inline-block;
  /* width: 1000px; */
  width: 100%;
}
.middle_content > div:nth-child(1) {
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
}
.statistics {
  align-items: center;
  display: flex;
  padding: 0;
  margin: 10px 0px 10px 0;
  width: 88%;
}
.statistics li {
  width: 100px;
  height: 55px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 0px;
  list-style: none;
  margin-right: 10px;
  padding: 2px 5px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.statistics li div:first-child {
  padding-bottom: 3px;
  font-size: 13px;
  border-bottom: 1px solid #666;
}
.statistics li span:nth-child(2) {
  font-size: 20px;
  font-weight: 900;
  color: #333;
}
.statistics li span:nth-child(3) {
  font-size: 14px;
  color: #666;
}
.button_size {
  width: 95px;
  height: 40px;
  margin-left: 20px;
}
li {
  list-style: none;
}
a {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
/* 左侧错误栏不被选中 */
.el-submenu .el-menu-item {
  user-select: none;
}
.right_border {
  width: 1000px;
  /* width: 100%; */
  display: flex;
  overflow: auto;
}
.right_border > div {
  width: 100px;
  height: 50px;
  line-height: 75px;
}
.title_cover {
  width: 95%;
  height: 320px;
  margin: 0px auto 50px;
  padding-right: 15px;
  overflow: auto;
}
.requirements {
  margin-bottom: 10px;
  font-size: 20px;
  display: flex;
}
.requirements span,
.requirements2 span,
.requirements div:first-child,
.img {
  font-size: 25px;
  color: #000;
}
.requirements div:first-child {
  width: 75px;
}
.requirements div:nth-child(2) {
  width: 665px;
}
.begin div:first-child {
  width: 95px;
}
.begin div:nth-child(2) {
  width: 645px;
}
.requirements2 > div div:nth-child(2) p {
  font-size: 20px;
}
.tags_badge {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  font-size: 12px;
  color: #fff;
}
.add .tags_badge {
  background: #3db95c;
}
.reduce .tags_badge {
  background: #fc500d;
}
.other_tags .tags_badge {
  background: #5e79fd;
}
/* 作文内容 */
.content {
  width: 98%;
  line-height: 40px;
  font-size: 25px;
  text-align: justify;
  padding: 0 10px;
  font-family: "Times New Roman", Times, serif;
  white-space: pre-wrap; /* 保留空白符序列，但是正常地进行换行。  */
  background: #eeeaea99;
  /* width: 950px; */
  height: 300px;
  overflow: auto;
  margin-bottom: 0;
}
/* .essay_cover {
  width: 975px;
  overflow: auto;
} */
.star_location {
  display: inline-block;
  padding-left: 10px;
}
.score_height {
  margin: 0;
  height: 39px;
  /* text-align: center;
  line-height: 39px;
  font-size: 15px;
  border-right: 1px solid #ddd; */
}
.score_select {
  width: 100%;
  height: 39px;
  color: #ffb800;
  font-size: 20px;
  font-weight: bold;
  border: 1px solid rgba(158 158 158 / 0.3);
  padding-left: 8px;
}
.score_select option {
  color: #333;
  border: 1px solid #ff0;
}
.score_size {
  margin: 0 auto;
  font-size: 15px;
  width:30px;
  height: 42px;
  line-height: 45px;
}
.article-star {
  margin-left: 30px;
}
.record {
  display: flex;
}
.record > div:nth-child(1) {
  width: 50%;
  height: 54px;
  border: 1px solid #e3d9d9;
}
.record > div:nth-child(2) {
  margin-top: 7px;
}
.record-col {
  border: 1px solid #e3d9d9;
  height: 121px;
}
.clearfix {
  padding: 10px 0;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.divider_css {
  width: 2px;
  background: #00f;
  margin: 0 8px 0 -10px;
}
.card_cover {
  width: 100%;
  position: relative;
}
.header_card {
  font-size: 16px;
  font-weight: 600;
  padding: 10px;
}
.box_card {
  background: #fff;
  border: 1px solid #e1e1e3;
}
.box_card_div {
  display: flex;
}
.box_card_div div {
  width: 150px;
  height: 50px;
  line-height: 50px;
}
.box_card_div div:nth-child(1) {
  padding-left:20px;
}
.box_card_div div:nth-child(2) {
  position: absolute;
  right: 0;
  text-align: center;
  color: #409eff;
}
.box_card button {
  height: 40px;
  width: 120px;
  border: 0;
  background: #67c23a;
  color: #fff;
  cursor: pointer;
}
.box_info {
  width: 65%;
  font-size: 8px;
  position: absolute;
  bottom: 10px;
  color: #9e9e9e;
  left: 30%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.word_font {
  font-size: 16px;
  font-weight: bolder;
}
.option_style {
  display: flex;
  flex-wrap: wrap;
  width: 546px;
}
.el_btn {
  width: 130px;
  height: 50px;
}
.dialog {
  position: absolute;
  width: 800px;
  height: 400px;
  border: 1px solid #333;
  cursor: move;
  display: none;
  border-radius: 25px;
  background: #fff;
  z-index: 2;
}
.timer {
  width: 100%;
  height: 54px;
  border: 1px solid #000;
  text-align: center;
  line-height: 54px;
  font-size: 25px;
  color: #f00;
  font-weight: 700;
}
.score_radio {
  margin: 50px 0 0 5px;
}
.submit_btn,
.temporary_btn {
  width: 130px;
  height: 45px;
  font-size: 18px;
  /* background: #ff8c26; */
}
.temporary_btn {
  margin-left: 30px;
}
.correct_details,
.evaluate_details {
  padding: 0 24px;
  width: 1320px;
  margin: 10px auto;
  background: #fff;
  border: 1px solid #fff;
}
.evaluate_details > div:nth-child(1) {
  width: 100%;
  height: 70px;
  padding: 20px 0;
  border-bottom: 1px solid #e0e3e9;
  margin-bottom: 10px;
}
.correct_details_title {
  font-size: 25px;
  font-weight: bolder;
  color: #333;
  width: 100%;
  height: 70px;
  padding: 20px 0;
}
.original_text {
  display: inline-block;
  width: 60%;
  font-size: 20px;
}
.annotation {
  display: inline-block;
  width: 40%;
  font-size: 15px;
}
.annotation > ul {
  margin: 0;
  padding: 0;
}
.annotation_li {
  margin-left: 5%;
  display: flex;
}
.annotation_li > div:nth-child(2) {
  width: 18%;
}
.annotation_li > div:nth-child(2) {
  width: 77%;
  /* word-break: keep-all; */
  /* white-space: pre; */
  /* word-wrap: break-word;
  white-space: pre-wrap; */
  word-break: normal;
  word-wrap: normal;
}
.subtract_score {
  color: #fc500d;
}
.add_score {
  color: #3db95c;
}
.other_score {
  color: #5e79fd;
}
.iconfont {
  margin-right: 13px;
}
.icon-circularwuxing-copy {
  color: #3db95c;
}
.icon-shenglvehao-copy {
  color: #5e79fd;
}
.tag_num {
  display: inline-block;
  margin-left: 55px;
  font-size: 20px;
  font-weight: 500;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  /* border: 1px solid #f00; */
}
.tag_type {
  display: inline-block;
  width: 48px;
  font-size: 16px;
}
.err_num {
  display: inline-block;
  font-size: 20px;
  font-weight: 500;
  width: 25px;
  height: 25px;
  /* border: 1px solid #f00; */
}
.err_type {
  display: inline-block;
  width: 70px;
  margin: 0 24px;
}
.correctFrame {
  display: flex;
}
</style>
